var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWLargeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1708.16 262.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:125px;font-family:GillSansMT-Bold, Gill Sans MT;font-weight:700;}.cls-1,.cls-11,.cls-12{fill:#fff;}.cls-2{letter-spacing:-0.04em;}.cls-3{letter-spacing:-0.01em;}.cls-4{letter-spacing:0.03em;}.cls-5{letter-spacing:0em;}.cls-6{letter-spacing:-0.02em;}.cls-7{letter-spacing:0em;}.cls-8{letter-spacing:-0.04em;}.cls-9{letter-spacing:-0.08em;}.cls-10{letter-spacing:-0.1em;}.cls-11{font-size:48px;font-family:GillSansMT, Gill Sans MT;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "w_large_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 174.73)"
  }, "Str", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 182.25,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 244.2,
    y: 0
  }, "wbe"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 483.64,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 538.45,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 598.21,
    y: 0
  }, "y")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(944.21 174.73)"
  }, "Phot", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 279.85,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 352.23,
    y: 0
  }, "gr"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 476.01,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 541.14,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 614.01,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 682.5,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 736.21,
    y: 0
  }, ".")), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(1216.24 230.53)"
  }, "By Sarah Hunt "), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M889.57,111.6c-1.63-8.28-6.06-15.35-9.81-22.72a4.12,4.12,0,0,0-.78-1.11c-7.93-7.57-14.71-16.48-25-21.29a11.48,11.48,0,0,1-1.32-1c4.84-1.32,9.59-2.24,11.9-7L857.8,59c0-.27-.11-.54-.16-.81,6.64-3.36,13.09-7,16.63-13.94a17.38,17.38,0,0,0,1.55-5.51c-3.76,5.51-9.68,4.54-14.88,5.4a96.66,96.66,0,0,1-12.21,1.38c-1.24,0-2.54-1.44-4.29-2.51a9.42,9.42,0,0,1-8.56,5.47c1.29-3.72,3.26-7.31,3.64-11.06.4-4-1.69-7.65-4.31-10.5l-19,10.25s-.25-.07-.33-.21c-2.15-3.65-2.13-3.57-6.33-2.39-6.27,1.76-12.39,3.8-17.19,8.53-.16.16-.5.14-1.36.35-.44-2.22-1-4.36-1.26-6.53a37.29,37.29,0,0,1,2-18.83c2.69-6.95,7.42-9.92,14.63-9,2.94.38,3.56-1.67,4.24-3.64s.88-3.83-1.66-4.7A11.76,11.76,0,0,1,807.44,0H802a3.14,3.14,0,0,1-.46.28c-12.86,5.84-18.89,16.92-16.82,31.19.78,5.36,1.88,10.68,2.67,16.29-3.07-11.16-14-13.26-21.75-19.47-3,3.36-7.54,5.24-8.88,10.06-.45,1.63-1.65,1.63-2.75.73-2.16-1.76-4.21-3.64-6.56-5.7-2.44,4.72-.86,9.83-1,15-1-.22-1.72-.39-2.41-.51-4.64-.81-9.35-2.56-13.9-2.21-7.36.56-13.35-1.92-19.2-5.67-.73-.46-1.5-.87-2.25-1.3l-.61.54,14,20.91c-1.86-.83-3.88-1.56-5.73-2.6s-3.57-2.38-5.55-3.32c3.77,7,9.28,11.84,18.31,13.22-1.5,1.18-2.22,1.74-2.93,2.32-3.8,3.08-8,5.76-11.29,9.34-4.35,4.8-8.63,9.61-11.8,15.58-3.49,6.55-5,13.62-7.82,20.29v21.35c1.31,5.31,2.06,10.83,4,15.87a275,275,0,0,0,11.81,26.35c5.52,10.66,11.62,21,17.72,31.38,4.8,8.14,9.93,16.1,15,24.07a141.3,141.3,0,0,0,9.69,14.1c2.25,2.72,5.47,4.74,8.48,6.73,6.9,4.55,14.66,6.65,22.83,7.45a16.5,16.5,0,0,1,2.37.53h12a35.94,35.94,0,0,1,5-1.15,46.49,46.49,0,0,0,21.32-7.7c7-4.55,11.3-11.55,15.73-18.3,5.33-8.13,10.29-16.51,15.23-24.9,3.73-6.34,7.1-12.89,10.74-19.28,3.51-6.17,7.54-12.06,10.66-18.42,5.62-11.44,10.48-23.21,12.28-36a6.93,6.93,0,0,1,.44-1.28V115A29.38,29.38,0,0,1,889.57,111.6Zm-77.8,72.2q-7.56,5.88-19.9,5.89a52.64,52.64,0,0,1-25.81-6.92V167.36a69.36,69.36,0,0,0,12.7,7,31.4,31.4,0,0,0,11.73,2.21q10.5,0,10.5-6.61a5.85,5.85,0,0,0-2.11-4.24q-2.1-2-10.11-4.87a102.51,102.51,0,0,1-12.7-5.32,24,24,0,0,1-8.09-7q-3.4-4.56-3.4-11.68A17.84,17.84,0,0,1,772,122q7.43-5.65,19.87-5.66,11.48,0,24.22,5.53v14q-14.24-6.39-22.68-6.4a15.6,15.6,0,0,0-7.66,1.61,4.84,4.84,0,0,0-2.84,4.28,5.25,5.25,0,0,0,2.05,3.89q2,1.84,10,4.77a107.62,107.62,0,0,1,12.7,5.42,24.71,24.71,0,0,1,8.22,7.07A18.5,18.5,0,0,1,819.32,168,19,19,0,0,1,811.77,183.8ZM843.52,187a9.14,9.14,0,0,1-12.91,0A9.12,9.12,0,0,1,837,171.46a9.15,9.15,0,0,1,9.16,9.11A8.73,8.73,0,0,1,843.52,187Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWLargeLogo);
export default __webpack_public_path__ + "static/media/w_large_logo.e62e1353d1f95a923518790a60c6cdde.svg";
export { ForwardRef as ReactComponent };